module.exports = __webpack_public_path__ + "img/logo.b39061e.png";